/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePalReauthCaseManagerRequest
 */
export interface CreatePalReauthCaseManagerRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePalReauthCaseManagerRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePalReauthCaseManagerRequest
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePalReauthCaseManagerRequest
     */
    fax?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePalReauthCaseManagerRequest
     */
    email?: string | null;
}

/**
 * Check if a given object implements the CreatePalReauthCaseManagerRequest interface.
 */
export function instanceOfCreatePalReauthCaseManagerRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function CreatePalReauthCaseManagerRequestFromJSON(json: any): CreatePalReauthCaseManagerRequest {
    return CreatePalReauthCaseManagerRequestFromJSONTyped(json, false);
}

export function CreatePalReauthCaseManagerRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePalReauthCaseManagerRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'fax': !exists(json, 'fax') ? undefined : json['fax'],
        'email': !exists(json, 'email') ? undefined : json['email'],
    };
}

export function CreatePalReauthCaseManagerRequestToJSON(value?: CreatePalReauthCaseManagerRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'phone': value.phone,
        'fax': value.fax,
        'email': value.email,
    };
}

